import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";
import shadows from "styles/shadows";

export const StyledCard = styled.div`
  &.expanded {
    box-shadow: ${shadows.shadowMd};
  }
  border-bottom: 1px solid ${colours.elexonBlue};

  &.first {
    border-top: 1px solid ${colours.elexonBlue};
  }
`;

export const StyledHeader = styled.header`
  cursor: pointer;
  box-shadow: none;
  display: flex;
  align-items: center;
`;

export const Title = styled.span`
  padding: 0;
  margin: 20px 0;
  font-size: ${fonts.mediumSmaller};
  font-weight: bold;
`;

export const Subtitle = styled.span`
  display: flex;
  align-items: center;
  font-size: ${fonts.xSmall};
  padding-right: 7px;
  margin-left: auto;
`;

export const StyledButton = styled.button`
  font-family: elexon-icons;
  color: ${colours.white};
  background-color: ${colours.elexonBlue};
  border-radius: 50%;
  width: 2.25em;
  aspect-ratio: 1;
  display: inline-grid;
  place-items: center;
  margin: auto 24px;
  font-size: ${fonts.xSmall};
  border: none;
  flex: 0 0 auto;
  align-self: center;
`;

export const StyledDiv = styled.div`
  display: none;
  padding: 0 13px 20px 77px;

  &.expanded {
    display: block;
  }
`;
